'use strict';

import $ from 'jquery';
require('jquery-confirm');
require('jquery-confirm/css/jquery-confirm.css');

/**
 * 共通ライブラリ
 */
class Library {
    /**
     * Cookieをセットする
     *
     * @param {*} myCookie Cookieキー
     * @param {*} myValue Cookieにセットする値
     * @param {*} myDay Cookie有効期限(日)
     */
    mySetCookie(myCookie, myValue, myDay) {
        let myExp = new Date(),
            myItem,
            myExpires;

        myExp.setTime(myExp.getTime() + (myDay * 24 * 60 * 60 * 1000));
        myItem = myCookie + '=' + escape(myValue) + ';path=/;';
        myExpires = 'expires=' + myExp.toGMTString();
        document.cookie = myItem + myExpires;
    }

    /**
     * Cookieを取得する
     *
     * @param {*} myCookie Cookieキー
     * @returns
     */
    myGetCookie(myCookie) {
        myCookie += '=';

        let myValue = null,
            myStr = document.cookie + ';',
            myOfst = myStr.indexOf(myCookie),
            myStart,
            myEnd;

        if (myOfst !== -1) {
            myStart = myOfst + myCookie.length;
            myEnd = myStr.indexOf(';', myStart);
            myValue = unescape(myStr.substring(myStart, myEnd));
        }

        return myValue;
    }

    /**
     * URIエンコードをしてcookie取得する
     *
     * @param {string} name 取得するcookie名
     * @returns {string|boolean}
     */
    getEncodeCookie(name) {
        if (name === undefined || name === null) {
            return false;
        }

        let decodeVal;

        try {
            decodeVal = decodeURIComponent(this.myGetCookie(name));
        } catch (e) {
            console.log(e);
            return null;
        }

        if (decodeVal === 'null') {
            decodeVal = null;
        }

        return decodeVal;
    }

    /**
     * URIデコードをしてcookie取得する
     *
     * @param {string} name 保存するcookie名
     * @param {string} val 保存データ
     * @param {integer} day 保存日数
     */
    setEncodeCookie(name, val, day) {
        if (name === undefined || name === null || val === undefined) {
            return false;
        }

        if (day === undefined || day === null) {
            day = 365;
        }

        this.mySetCookie(name, encodeURIComponent(val), day);
    }

    /**
     * 指定のGETパラメータを取得
     *
     * @param {type} name
     * @returns {getQueryString.arg|Object}
     */
    getQueryString(name) {
        let arg = new Object,
            url = location.search.substring(1).split('&'),
            key,
            urlLength = url.length;

        for (let i = 0; urlLength > i; i++) {
            if (!url[i]) {
                continue;
            }
            key = url[i].split('=');
            arg[key[0]] = key[1];
        }

        if (arg[name]) {
            return arg[name];
        }

        return false;
    }

    /**
     * jquery-confirm $.alertを実行する
     *
     * @param {String} title アラートタイトル
     * @param {String} content アラートテキスト
     */
    jqAlert(title, content) {
        if (title === undefined) {
            title = '';
        }

        if (content === undefined) {
            content = '';
        }

        // PC,SPで横幅変動
        let boxWidth;
        if ($('#uaStr').val() === 'pc') {
            boxWidth = '500px'
        } else {
            boxWidth = '80%';
        }

        //アラート表示
        $.alert({
            title: title,
            content: content,
            closeIcon: true,
            type: 'matsui',
            boxWidth: boxWidth,
            useBootstrap: false,
            backgroundDismiss: true,
            animateFromElement: false,
            typeAnimated: false,
            animation: 'opacity',
            closeAnimation: 'opacity'
        });
    }

    /**
     * jquery-confirm $.confirm を実行する
     *
     * @param {String} title 確認ダイアログのタイトル
     * @param {String} content 確認メッセージ
     * @param {Function} onOk 「OK」を押した時の処理
     * @param {Function} onCancel 「キャンセル」を押した時の処理
     */
    jqConfirm(title, content, onOk, onCancel) {
        if (title === undefined) {
            title = '';
        }

        if (content === undefined) {
            content = '';
        }

        let boxWidth;
        if ($('#uaStr').val() === 'pc') {
            boxWidth = '500px';
        } else {
            boxWidth = '80%';
        }

        $.confirm({
            title: title,
            content: content,
            type: 'matsui',
            boxWidth: boxWidth,
            useBootstrap: false,
            buttons: {
                OK: {
                    btnClass: 'btn-matsui',
                    action: function () {
                        if (typeof onOk === 'function') {
                            onOk();
                        }
                    }
                },
                キャンセル: {
                    action: function () {
                        if (typeof onCancel === 'function') {
                            onCancel();
                        }
                    }
                }
            },
            closeIcon: true,
            backgroundDismiss: true,
            animateFromElement: false,
            typeAnimated: false,
            animation: 'opacity',
            closeAnimation: 'opacity'
        });
    }

    /**
     * 整数又は小数かチェックする
     * @param {type} numVal
     * @returns {Boolean}
     */
    isNumber(numVal) {
        // チェック条件パターン
        let pattern = /^[-]?([1-9]\d*|0)(\.\d+)?$/;

        // 数値チェック
        return pattern.test(numVal);
    }

    /**
     * 日付のフォーマット化
     */
    dateFormat(date, format) {
        date = new Date(date);
        format = format.replace(/yyyy/g, date.getFullYear());
        format = format.replace(/MM/g, ('0' + (date.getMonth() + 1)).slice(-2));
        format = format.replace(/dd/g, ('0' + date.getDate()).slice(-2));

        return format;
    };

    /**
     * 決算期区分の表示形式を変更
     * @param {String} fy 決算期
     * @returns {String}
     */
    convFiscalTermType(type) {
        switch (type) {
            case 'Q1':
                type = '1Q';
                break;
            case 'H1':
            case 'Q2':
                type = '2Q';
                break;
            case 'Q3':
                type = '3Q';
                break;
            case 'Q4':
                type = '4Q';
                break;
            case 'Q5':
                type = '5Q';
                break;
            case 'FY':
                type = '本';
                break;
            default:
                type = '－';
        }
        return type;
    }

    // UAによるブラウザ判定
    isFireFox() {
        const agent = window.navigator.userAgent.toLowerCase();
        if (agent.indexOf('firefox') != -1) {
            return true;
        }

        return false;
    }

    isSafari() {
        const agent = window.navigator.userAgent.toLowerCase()
        // chrome/edgeのUAに'safari'が含まれるためsafariのみで判定
        if (agent.indexOf('safari') != -1 && agent.indexOf('chrome') == -1 && agent.indexOf('edge') == -1) {
            return true;
        }

        return false;
    }

    isIpad() {
        const agent = window.navigator.userAgent.toLowerCase()
        if (
            agent.indexOf('ipad') != -1 ||
            (agent.indexOf('macintosh') != -1 && 'ontouchend' in document)
        ) {
            return true;
        }

        return false;
    }

    isIphone() {
        const agent = window.navigator.userAgent.toLowerCase()
        if (agent.indexOf('iphone') != -1) {
            return true;
        }

        return false;
    }

    isAndroid() {
        const agent = window.navigator.userAgent.toLowerCase()
        if (agent.indexOf('android') != -1) {
            return true;
        }

        return false;
    }

    /**
     * bodyにローディングオーバーレイを表示
     */
    showLoadingOverlay() {
        $('.loading_overlay').remove(); // 重複表示防止

        let loadingOverlay = $('<div class="loading_overlay"></div>');
        $('body').append(loadingOverlay);
        loadingOverlay.show();
    }

    /**
     * ローディングオーバーレイ削除
     */
    removeLoadingOverlay() {
        $('.loading_overlay').remove();
    }

    /**
     * チェックボックス全選択、全解除
     *
     * @param {string} all_check_function_id
     * @param {string} all_check_function_class
     */
    selectCheckAll(all_check_function_id, all_check_function_class) {
        $(all_check_function_id).on('click', () => {
            $(all_check_function_class).prop('checked', $(all_check_function_id).prop('checked'));
        });
    };

    /**
     * 日付入力チェック
     *
     * @param {string} strDate
     */
    checkDate(strDate) {
        if (!strDate.match(/^\d{4}\/\d{1,2}\/\d{1,2}$/)) {
            return false;
        }
        let y = strDate.split('/')[0];
        let m = strDate.split('/')[1] - 1;
        let d = strDate.split('/')[2];
        let date = new Date(y, m, d);
        if (date.getFullYear() != y || date.getMonth() != m || date.getDate() != d) {
            return false;
        }
        return true;
    }

    /**
     * クライアント出力文字サニタイズ(引数は関数内部で文字列に型変換しているため型はなんでもよい)
     *
     * @param  {any} str
     * @return {string} str
     */
    escapeHtml(str) {
        str = String(str);
        str = str.replace(/&/g, '&amp;');
        str = str.replace(/</g, '&lt;');
        str = str.replace(/>/g, '&gt;');
        str = str.replace(/"/g, '&quot;');
        str = str.replace(/'/g, '&#39;');
        return str;
    }

    /**
     * URLに指定したGETパラメータが含まれるかチェック
     *
     * @param  {string} name GETパラメータkey
     * @return {bool}
     */
    hasParam(name) {
        return new RegExp('[?&]' + name + '(=|&|$)').test(window.location.search);
    }

    /**
     * 銘柄比較画面:グループ編集中チェック
     *
     * @return {bool} true:編集中,false:未編集
     */
    isComparisonEditing() {
        let currentPath = window.location.pathname;

        if (currentPath === '/comparison' && this.hasParam('shareClassIds')) {
            // pathnameとGETパラメータ有無で編集中判定
            return true;
        }
        return false;
    }

    /**
     * 銘柄比較画面:編集中チェック・画面遷移確認
     *
     * @param  {function|null} onOk OK選択時/確認不要時のコールバック関数
     * @param  {function|null} onCancel キャンセル選択時のコールバック関数
     */
    checkAndConfirmComparisonEditing(onOk, onCancel) {
        // 画面切替確認メッセージ
        const CONFIRM_TITLE = 'このページを離れますか？';
        const CONFIRM_MESSAGE = '編集中の内容は保存されていません<br>「グループ保存」ボタンより保存可能です';

        if (this.isComparisonEditing()) {
            // グループ編集中の画面遷移確認
            this.jqConfirm(CONFIRM_TITLE, CONFIRM_MESSAGE, onOk, onCancel);
        } else {
            // グループ編集中でない場合は確認なし
            if (typeof onOk === 'function') {
                onOk();
            }
        }
    }
}

export const lib = new Library();
